module.exports = __webpack_public_path__ + "img/services-stress-test-side.c8c548fa.png";